import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import { CONFIGURATION_COLUMNS, LICENSING_COLUMNS } from "./columns";

const ItglueAssetList = ({
  data,
  loading,
  sorted,
  page,
  pageSize,
  pages,
  onPageSizeChange,
  onPageChange,
  onSortedChange,
  isMobile,
  assetType
}) => {
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    switch (assetType) {
      case "Licensing":
        setColumns(LICENSING_COLUMNS);
        break;
      case "Configurations":
        setColumns(CONFIGURATION_COLUMNS);
        break;
      default:
        break;
    }
  }, [assetType]);

  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <ReactTable
        className="-highlight"
        columns={columns}
        data={data}
        manual
        sorted={sorted}
        pages={pages}
        page={page}
        pageSize={Math.min(data.length, pageSize)}
        showPagination={pages > 1}
        showPageSizeOptions={!isMobile}
        onSortedChange={onSortedChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};

ItglueAssetList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  isMobile: PropTypes.bool,
  assetType: PropTypes.string
};

ItglueAssetList.defaultProps = {
  assetType: ""
};

export default ItglueAssetList;
